import "./Roadmap.scss";

import RoadmapIcon1 from "../../assets/images/roadmap-icon-1.svg";
import RoadmapIcon2 from "../../assets/images/roadmap-icon-2.svg";
import RoadmapIcon3 from "../../assets/images/roadmap-icon-3.svg";
import RoadmapIcon4 from "../../assets/images/roadmap-icon-4.svg";

import RoadmapCard from "../../components/Home/RoadmapCard";
import { useEffect, useRef } from "react";

import { ReactComponent as RoadmapProgress } from "../../assets/images/roadmap-progress.svg";
import { ReactComponent as RoadmapProgressMobile } from "../../assets/images/roadmap-progress-mobile.svg";

export default function Roadmap() {
	// Roadmap data structure
	const roadmapData = [
		{
			id: 1,
			position: "left",
			indicator_title: "P1",
			icon: RoadmapIcon1,
			title: "Launch And Early Development",
			description: [
				"Website & Branding Launch",
				"Smart Contract Development & Deployment",
				"Early GATR Relay Network Development",
				"Early Privacy Engine Development",
				"Community Growth & Strategic Partnerships",
				"$GATR Token Launch",
			],
		},
		{
			id: 2,
			position: "right",
			indicator_title: "P2",
			icon: RoadmapIcon2,
			title: "Core Systems and AI Integration",
			description: [
				"Gatr Relay Network Activation",
				"AI Agent Development & Initial Deployment",
				"AI-Driven Gas Fee Optimization",
				"Smart Contract Morphing Expansion",
				"Privacy Engine Refinement",
				"Staking & Governance Activation",
				"GatrSwap Development",
				"Cross-Chain Privacy Expansion",
			],
		},
		{
			id: 3,
			position: "left",
			indicator_title: "P3",
			icon: RoadmapIcon3,
			title: "Ecosystem Expansion & Full Privacy Utility",
			description: [
				"Full GatrSwap Deployment",
				"Advanced Smart Contract Morphing & Execution Path Shuffling",
				"AI Agent Scaling & Threat Response Automation",
				"Mobile & Browser Privacy Integration",
				"Institutional & Enterprise Adoption",
				"Cross-Chain Privacy Scaling",
			],
		},
		{
			id: 4,
			position: "right",
			indicator_title: "P4",
			icon: RoadmapIcon4,
			title: "Full Brand Expansion",
			description: [
				"AI-Driven Autonomous Privacy Engine",
				"Full-Scale Smart Contract Morphing",
				"AI Agent: Autonomous Network-Wide Privacy Optimization",
				"Advanced Gas Fee Optimization & AI Routing",
				"Real-World Privacy & Compliance Adoption",
				"Cross-Chain Privacy Expansion (Full Multi-Chain Support)",
				"Perpetual Development & Governance",
			],
		},
	];

	// Filter roadmap items by position
	const leftItems = roadmapData.filter((item) => item.position === "left");
	const rightItems = roadmapData.filter((item) => item.position === "right");

	const roadmapDesktopRef = useRef(null);
	const roadmapMobileRef = useRef(null);

	useEffect(() => {
		// Function to calculate progress for roadmap
		const calculateProgress = (element, startOffset = 0, endOffset = 0) => {
			if (!element) return 0;
			const rect = element.getBoundingClientRect();
			const windowHeight = window.innerHeight;

			// Start when the top of the element enters the viewport (adjusted by startOffset)
			// End when the bottom of the element leaves the viewport (adjusted by endOffset)
			const startPosition = windowHeight + startOffset; // When top enters viewport
			const endPosition = 0 - rect.height - endOffset; // When bottom leaves viewport

			const currentPosition = rect.top;

			// Calculate progress percentage (0-100)
			const totalDistance = startPosition - endPosition;
			const currentProgress = startPosition - currentPosition;
			const progressPercentage = Math.min(
				100,
				Math.max(0, (currentProgress / totalDistance) * 100)
			);

			return progressPercentage;
		};

		const updateDesktopRoadmap = () => {
			var progress = calculateProgress(roadmapDesktopRef.current, -150);

			const roadmapProgress =
				roadmapDesktopRef.current.querySelector(".roadmap-progress"); // this is svg
			const progressLine =
				roadmapDesktopRef.current.querySelector("#roadmap-line"); // line in svg
			const roadmapLogo =
				roadmapDesktopRef.current.querySelector("#roadmap-logo"); // logo in svg

			const Phase1Label =
				roadmapDesktopRef.current.querySelector("#phase-1-label");
			const Phase2Label =
				roadmapDesktopRef.current.querySelector("#phase-2-label");
			const Phase3Label =
				roadmapDesktopRef.current.querySelector("#phase-3-label");
			const Phase4Label =
				roadmapDesktopRef.current.querySelector("#phase-4-label");

			const pointAtPercentage = progressLine.getPointAtLength(
				(progressLine.getTotalLength() * progress) / 100
			);

			const x_offset = -200; // Adjust this value to move the logo left/right
			const y_offset = -50; // Adjust this value to move the logo up/down

			// Set the position of the logo
			roadmapLogo.setAttribute(
				"transform",
				`translate(${pointAtPercentage.x + x_offset}, ${
					pointAtPercentage.y + y_offset
				})`
			);

			// show / hide labels based on progress
			Phase1Label.style.opacity =
				progress >= 15 ? Math.min(1, (progress - 15) / 5) : 0;
			Phase2Label.style.opacity =
				progress >= 36 ? Math.min(1, (progress - 36) / 5) : 0;
			Phase3Label.style.opacity =
				progress >= 60 ? Math.min(1, (progress - 60) / 5) : 0;
			Phase4Label.style.opacity =
				progress >= 83 ? Math.min(1, (progress - 83) / 5) : 0;
		};

		const updateMobileRoadmap = () => {
			var progress = calculateProgress(roadmapMobileRef.current, -50);

			const roadmapProgress =
				roadmapMobileRef.current.querySelector(".roadmap-progress"); // this is svg
			const progressLine =
				roadmapMobileRef.current.querySelector("#roadmap-line"); // line in svg
			const roadmapLogo =
				roadmapMobileRef.current.querySelector("#roadmap-logo"); // logo in svg

			const Phase1Label =
				roadmapMobileRef.current.querySelector("#phase-1-label");
			const Phase2Label =
				roadmapMobileRef.current.querySelector("#phase-2-label");
			const Phase3Label =
				roadmapMobileRef.current.querySelector("#phase-3-label");
			const Phase4Label =
				roadmapMobileRef.current.querySelector("#phase-4-label");

			const pointAtPercentage = progressLine.getPointAtLength(
				(progressLine.getTotalLength() * progress) / 100
			);

			const x_offset = -63; // Adjust this value to move the logo left/right
			const y_offset = -270; // Adjust this value to move the logo up/down

			// Set the position of the logo
			roadmapLogo.setAttribute(
				"transform",
				`translate(${pointAtPercentage.x + x_offset}, ${
					pointAtPercentage.y + y_offset
				})`
			);

			// show / hide labels based on progress
			Phase1Label.style.opacity =
				progress >= 2 ? Math.min(1, (progress - 2) / 5) : 0;
			Phase2Label.style.opacity =
				progress >= 28 ? Math.min(1, (progress - 28) / 5) : 0;
			Phase3Label.style.opacity =
				progress >= 54 ? Math.min(1, (progress - 54) / 5) : 0;
			Phase4Label.style.opacity =
				progress >= 77 ? Math.min(1, (progress - 77) / 5) : 0;
		};

		// Combined scroll handler
		const handleScroll = () => {
			// check browser window width
			const isMobile = window.innerWidth <= 1140;

			isMobile ? updateMobileRoadmap() : updateDesktopRoadmap();
		};

		// Add scroll event listener
		window.addEventListener("scroll", handleScroll);

		// Initial calculation on mount
		handleScroll();

		// Clean up event listener on component unmount
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	return (
		<>
			<div className="roadmap" id="roadmap">
				<div className="roadmap-content-wrapper content-wrapper-lg">
					<h1 className="roadmap-title">ROADMAP</h1>

					<div className="roadmap-desktop" ref={roadmapDesktopRef}>
						<div className="roadmap-left">
							{leftItems.map((item) => (
								<RoadmapCard
									key={item.id}
									className="roadmap-item"
									data-aos="zoom-in"
								>
									<div className="roadmap-card-icon">
										<img
											src={item.icon}
											alt={`Roadmap Icon ${item.id}`}
											className="icon"
										/>
									</div>
									<h6 className="roadmap-card-title">
										{item.title}
									</h6>
									<div className="roadmap-card-description">
										{item.description.map((desc, index) => (
											<div
												key={index}
												className="desc-item"
											>
												- {desc}
											</div>
										))}
									</div>
								</RoadmapCard>
							))}
						</div>

						<div className="roadmap-center">
							<div className="roadmap-progress-wrapper">
								<RoadmapProgress className="roadmap-progress" />
							</div>
						</div>

						<div className="roadmap-right">
							{rightItems.map((item) => (
								<RoadmapCard
									key={item.id}
									className="roadmap-item"
									data-aos="zoom-in"
								>
									<div className="roadmap-card-icon">
										<img
											src={item.icon}
											alt={`Roadmap Icon ${item.id}`}
											className="icon"
										/>
									</div>
									<h6 className="roadmap-card-title">
										{item.title}
									</h6>
									<div className="roadmap-card-description">
										{item.description.map((desc, index) => (
											<div
												key={index}
												className="desc-item"
											>
												- {desc}
											</div>
										))}
									</div>
								</RoadmapCard>
							))}
						</div>
					</div>

					<div className="roadmap-mobile" ref={roadmapMobileRef}>
						<div className="roadmap-progress-wrapper">
							<RoadmapProgressMobile className="roadmap-progress" />
						</div>

						<div className="roadmap-items">
							{roadmapData.map((item) => (
								<RoadmapCard
									key={item.id}
									className="roadmap-item"
									data-aos="zoom-in"
								>
									<div className="roadmap-card-icon">
										<img
											src={item.icon}
											alt={`Roadmap Icon ${item.id}`}
											className="icon"
										/>
									</div>
									<h6 className="roadmap-card-title">
										{item.title}
									</h6>
									<div className="roadmap-card-description">
										{item.description.map((desc, index) => (
											<div
												key={index}
												className="desc-item"
											>
												- {desc}
											</div>
										))}
									</div>
								</RoadmapCard>
							))}
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
